import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../services/i18nService';
import navigationService from '../../services/NavigationService';
import securityService from '../../services/SecurityService';
import PasswordInput from './PasswordInput';
import styles from './options.scss';

class ConfirmationDialog extends React.Component {
    static propTypes = {
        actionHandler: PropTypes.func.isRequired,
        mainButtonText: PropTypes.string.isRequired,
        hideCancelButton: PropTypes.bool,
        requireInvigilatorPassword: PropTypes.bool,
        text: PropTypes.string,
        contentChildren: PropTypes.object, // extra react children if needed
        fileBlobForLink: PropTypes.string, // file save for seb mac
        fileBlobName: PropTypes.string, // file save for seb mac
        confirmButtonA11y: PropTypes.object,
        cancelButtonA11y: PropTypes.object,
    };

    state = { passwordStatus: undefined };

    handlePasswordChange = (e) => {
        const passwordMatches = securityService.verifyInvigilatorPassword(e.target.value);

        if (passwordMatches) {
            this.setState({ passwordStatus: 'correct' });
        } else {
            this.setState({ passwordStatus: 'wrong' });
        }
    };

    render() {
        const { passwordStatus } = this.state;
        const { requireInvigilatorPassword, fileBlobForLink, fileBlobName, hideCancelButton } = this.props;
        const mainBtnEnabled = !requireInvigilatorPassword || passwordStatus === 'correct';
        const classes = ['main'];
        if (!mainBtnEnabled) {
            classes.push('disabled');
        }
        return (
            <div className={styles.confirmationDialog}>
                <div className={styles.formWrapper}>
                    {
                        this.props.text
                            ? <div dangerouslySetInnerHTML={{ __html: this.props.text }} />
                            : null

                    }
                    {
                        this.props.contentChildren
                            ? this.props.contentChildren
                            : null
                    }
                    {
                        requireInvigilatorPassword
                            ? <PasswordInput changeHandler={this.handlePasswordChange} />
                            : null
                    }

                    <div className={styles.confirmationButtonGroup}>
                        {
                            !hideCancelButton ?
                                <button
                                    className="cancel"
                                    onClick={navigationService.navigateToOptions}
                                    {...(this.props.cancelButtonA11y || {})}
                                >
                                    {t('generic.cancel')}
                                </button>
                                : null
                        }
                        {
                            fileBlobForLink && mainBtnEnabled ?
                                <a
                                    className={classes.join(' ')}
                                    download={fileBlobName}
                                    href={fileBlobForLink}
                                    {...(this.props.confirmButtonA11y || {})}
                                >
                                    {this.props.mainButtonText}
                                </a>
                                :
                                <button
                                    className={classes.join(' ')}
                                    disabled={!mainBtnEnabled}
                                    onClick={this.props.actionHandler}
                                    {...(this.props.confirmButtonA11y || {})}
                                >
                                    {this.props.mainButtonText}
                                </button>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmationDialog;
